import { call, ForkEffect, put, takeLatest, select } from 'redux-saga/effects'
import {
  ClientDataGeneratorYield,
  FETCH_CLIENT_DATA,
  FETCH_CLIENT_DATA_FAIL,
  FETCH_CLIENT_DATA_SUCCESS,
  IClientData,
  IError,
  IFetchClientData,
  ClientDataGeneratorReturn,
} from '.'
import { ApiResponse } from '../../interfaces'
import fetchClientDataService from '../../services/fetchClientData'
import { SEND_TO_LOGIN_FALLBACK } from '../sendTo'
import { RootStore } from '../store'

function* fetchClientData({
  payload: { userId, sessionToken, middleware },
}: IFetchClientData): Generator<ClientDataGeneratorYield, void, ClientDataGeneratorReturn> {
  const clientData = yield select((state: RootStore) => state.clientData.data)
  const { document } = clientData as IClientData

  const response = yield call(fetchClientDataService, userId, sessionToken, middleware)
  const { success, data, status } = response as ApiResponse<IClientData | IError>

  if (success) {
    const response = data as IClientData

    yield put({
      type: FETCH_CLIENT_DATA_SUCCESS,
      payload: response,
    })
  } else {
    const { message, details } = data as IError

    yield put({
      type: FETCH_CLIENT_DATA_FAIL,
      payload: {
        message,
        details,
        status,
      },
    })

    if (status === 404 && !document) {
      yield put({
        type: SEND_TO_LOGIN_FALLBACK,
        payload: { userId },
      })
    }
  }
}

export function* fetchClientDataSaga(): Generator<ForkEffect<never>, void, unknown> {
  yield takeLatest(FETCH_CLIENT_DATA, fetchClientData)
}
